export default "/_next/static/chunks/fonts/Source Sans Pro SemiboldIt-972b642e35323937d11371054d69c988.otf";